import * as React from "react";
const SvgBuilding = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M11.252 1.871v2.815H4.686v3.752H2.812V20.62H1.69v1.506H22.31v-1.506h-1.122V8.438h-1.874V4.686h-6.566V3.379h1.123V1.87h-1.31Zm-5.06 4.32h11.617v2.246H6.19V7.314Zm5.81 3.752 7.684.002.002 5.338.002 5.338h-1.786v-7.498h-4.78v7.498h-2.247v-7.498H6.096v7.498H4.31v-5.336c0-2.935.001-5.337.003-5.34.003-.002 3.462-.003 7.688-.002zm-4.408 4.688h1.775v5.99H7.594v-2.996Zm7.037 0h1.775v5.99h-1.775v-2.996Z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgBuilding;
